// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M10 12L6 8L10 4'];
